<div [hidden]="!loading" *ngIf="!loading; else loadinganimation" ></div>
<img [hidden]="loading" (load)="onLoad()" (error)="onError()" [src]="imagesrc" [style.max-width]="maxsize + 'px'" [style.max-height]="maxsize + 'px'">
<ng-template #loadinganimation>
  <wol-loader [size]="loadersize" [margin]="loadermargin"></wol-loader>
</ng-template>
